import { render, staticRenderFns } from "./BatteryDrawerDetail.vue?vue&type=template&id=52571a70"
import script from "./BatteryDrawerDetail.vue?vue&type=script&lang=js"
export * from "./BatteryDrawerDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports